<template>
  <Dialog 
    hideModalButtons
    center
    size="extra-large"
    :title="$route.params.ticketId"
  >
    <chat 
      :messages="messages" 
      :location="location"
      :ticketId="$route.params.ticketId" 
    />
  </Dialog>
</template>
<script>
import Chat from '@/components/Chat';
import Dialog from '@/components/Dialog';
import { db } from '@/helpers/firebase';

export default {
  components: { Dialog, Chat },
  created() {
    this.ref = db.child(`tickets/${this.$route.params.ticketId}`);
    this.ref.on('value', snapshot => {
      const ticket = snapshot.val() || {};
      this.messages = Object.values(ticket.messages || {}) 
      this.location = this.formatLocation(ticket.ipstack);
    });
  },
  destroyed() {
    this.ref.off('value');
  },
  data() {
    return {
      messages: [],
      location: {}, 
    };
  },
  methods: {
    formatLocation(ipstack = {}) {
      return `${ipstack.country_name}, ${ipstack.region_name}, ${ipstack.city}`;
    } 
  }
};
</script>



// WEBPACK FOOTER //
// src/modals/Chat.vue